import { render } from "./ShowIntensiveCare.vue?vue&type=template&id=560761aa&scoped=true"
import script from "./ShowIntensiveCare.vue?vue&type=script&lang=js"
export * from "./ShowIntensiveCare.vue?vue&type=script&lang=js"

import "./ShowIntensiveCare.vue?vue&type=style&index=0&id=560761aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560761aa"]])

export default __exports__